import React, { useEffect, useState } from 'react';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import './tickets.css';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'react-bootstrap';
import UploadIcon from '../../assets/icons/ticket/upload.svg'
import ShowTicket from './showTicket'
import { getTicketList } from '../../utils/api';
import useToastNotification from '../../hooks/useToastNotification';
import LoaderPage from '../loader/dotloader';

//icon
import Box from '../../assets/icons/ticket/box.svg'
import Crown from '../../assets/icons/ticket/crown.svg'
import Info from '../../assets/icons/ticket/info.svg'
import Receipt from '../../assets/icons/ticket/receipt.svg'
import Status from '../../assets/icons/ticket/status.svg'
function AddTicket() {
    const [loading, setLoading] = useState(false);
    const [showTicket, setShowTicket] = useState(false);
        const [ticketDetail, setTicketDetail] = useState('');
    
    const [items, setItems] = useState([]);
    const [orderNumber, setOrderNumber] = useState('');
    const [description, setDescription] = useState('');
    const [title, setTitle] = useState('');
    const [ticketId, setTicketId] = useState('');
    const [file, setFile] = useState(null);
    const { showError, showSuccess } = useToastNotification();

    const fetchTicket = async () => {
        try {
            // setLoading(true)
            let pay = {
                status: 'open',
                userId: JSON.parse(localStorage.getItem('userInfo')).si
            }
            let res = await getTicketList(pay)
            if (res.data != null) {
                setItems(res.data)
            } else {
                // showError(res.data)
            }
        } catch (error) {
            showError('خطا در برقراری ارتباط')
        } finally {
            // setLoading(false)
        }
    }

    useEffect(() => {
        fetchTicket()
    }, [])

    function convertToPersianNumbers(input) {
        const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        return input.replace(/\d/g, (digit) => persianDigits[digit]);
    }


    return (
        <>
            {loading && <LoaderPage isLoading={loading} />}

            {showTicket ? (<>
                <ShowTicket ticketId={ticketId} ticketDetail={ticketDetail}/>
            </>) : (
                <>
                    {items.length > 0 && items.map((item, index) => (
                        <div className='ticket-box mt-2' key={index}>
                            <div className='row gx-2 gy-3'>
                                <div className='col-sm-12 col-md-6 col-lg-3'>
                                    <div className='d-flex align-items-center gap-2'>
                                        <img src={Receipt} alt="" />
                                        <h6 className='mb-0'>شماره تیکت: {convertToPersianNumbers((item.Si).toString())}</h6>
                                    </div>
                                </div>
                                <div className='col-sm-12 col-md-6 col-lg-3'>
                                    <div className='d-flex align-items-center gap-2'>
                                        <img src={Crown} alt="" />
                                        <h6 className='mb-0'>اهمیت: فوری</h6>
                                    </div>
                                </div>
                                <div className='col-sm-12 col-md-6 col-lg-3'>
                                    <div className='d-flex align-items-center gap-2'>
                                        <img src={Box} alt="" />
                                        <h6 className='mb-0'>سفارش: {convertToPersianNumbers(item.NumFactor.toString())}</h6>
                                    </div>
                                </div>
                                <div className='row bottom-row gx-2 gy-3'>

                                    <div className='col-sm-12 col-md-6 col-lg-3'>
                                        <div className='d-flex align-items-center gap-2'>
                                            <img src={Info} alt="" />
                                            <h6 className='mb-0'>موضوع: {convertToPersianNumbers(item.Onvan)}</h6>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-6 col-lg-3'>
                                        <div className='d-flex align-items-center gap-2'>
                                            <img src={Status} alt="" />
                                            <h6 className='mb-0'>اعلانات: در انتظار پاسخ</h6>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 d-flex align-items-center justify-content-end">
                                <button className='btn btn-primary' onClick={() => {setShowTicket(true);setTicketId(item.Si);setTicketDetail(item)}}>مشاهده تیکت</button>
                            </div>
                        </div>
                    ))}


                </>
            )}
        </>
    );
}

export default AddTicket;
